<form [formGroup]="form" (ngSubmit)="submit()" class="tw-flex tw-flex-col tw-items-center tw-pt-6">
  <mh-auth-form-header [titleKey]="titleKey()" [explainKey]="explainKey()"></mh-auth-form-header>

  <div class="tw-mt-[35px] tw-flex tw-w-full tw-max-w-[417px] tw-flex-col tw-gap-[25px]">
    <mh-core-lib-text-input
      [formGroup]="form"
      keyControl="new_password"
      [type]="showNewPassword() ? 'text' : 'password'"
      [hasIcon]="true"
      [iconClass]="(showNewPassword() ? 'fas fa-eye-slash' : 'fas fa-eye') + ' !tw-top-1/2 -tw-translate-y-1/2'"
      [iconAriaLabel]="'set_password.toggle_password_visibility' | translate"
      (clicked)="showNewPassword.set(!showNewPassword())"
      [placeholder]="'set_password.new_password_placeholder' | translate"
      [ariaLabel]="'set_password.new_password_placeholder' | translate"
      autocomplete="new-password"
      [className]="newPasswordClass()">
    </mh-core-lib-text-input>

    <mh-core-lib-text-input
      [formGroup]="form"
      keyControl="confirm_password"
      [type]="showConfirmPassword() ? 'text' : 'password'"
      [hasIcon]="true"
      [iconClass]="(showConfirmPassword() ? 'fas fa-eye-slash' : 'fas fa-eye') + ' !tw-top-1/2 -tw-translate-y-1/2'"
      [iconAriaLabel]="'set_password.toggle_password_visibility' | translate"
      (clicked)="showConfirmPassword.set(!showConfirmPassword())"
      [placeholder]="'set_password.confirm_password_placeholder' | translate"
      [ariaLabel]="'set_password.confirm_password_placeholder' | translate"
      autocomplete="new-password"
      className="mh-auth-input">
    </mh-core-lib-text-input>
  </div>

  @if (serverErrorKey()) {
    <p class="tw-mb-0 tw-mt-[6px] tw-w-full tw-max-w-[417px] tw-font-rubik tw-text-sm tw-text-red-500">
      <i class="fas fa-times"></i> {{ serverErrorKey() | translate }}
    </p>
  }

  <div class="tw-mt-4 tw-w-full tw-max-w-[417px]">
    <mh-strength-password
      [possibleErrors]="possibleErrors"
      [newPassControl]="newPassword"
      [confirmControl]="confirmPassword"></mh-strength-password>
  </div>

  <div class="tw-mt-[29px]">
    <mh-core-lib-button
      [isPrimary]="true"
      [isDisabled]="!canSubmit()"
      [isDownloading]="saving()"
      [text]="'set_password.submit' | translate"
      customClass="!tw-w-auto !tw-min-w-[220px] tw-whitespace-nowrap"
      loaderClass="tw-mx-auto"
      textClass="tw-font-rubik"></mh-core-lib-button>
  </div>
</form>
